// components/shared/SeoHelmet.tsx
import React from "react";
import { Helmet } from "react-helmet";

type MetaTag = {
  name?: string;
  property?: string;
  content: string;
};

interface SeoHelmetProps {
  title: string;
  metaTags?: MetaTag[];
}

const SeoHelmet: React.FC<SeoHelmetProps> = ({ title, metaTags = [] }) => {
  return (
    <Helmet>
      <title>{title}</title>
      {metaTags.map((tag, index) => {
        // Renders either <meta name="..." /> or <meta property="..." />
        if (tag.name) {
          return <meta key={index} name={tag.name} content={tag.content} />;
        } else if (tag.property) {
          return (
            <meta key={index} property={tag.property} content={tag.content} />
          );
        }
        return null;
      })}
    </Helmet>
  );
};

export default SeoHelmet;
